export enum ToastType {
  Success = "Success",
  Error = "Error",
  Info = "Info",
}
